/* eslint-disable */
<template>
  <div class="ManageBooking">
    <Navigation indexProps="4"/>
    <div class="top-panel">
      <Header/>
      <div v-if="showContent" class="header-title-section">
        <div class="header-title"><h1>{{ setTitle() }}</h1></div>
        <div class="header-sub-title">{{ setSubTitle() }}</div>
      </div>
      <div v-else class="header-title-section"><h5>Invalid Booking Information</h5></div>
    </div>
    <div class="panel">
      <ClientBookingMenu indexProps="3"/>
      <AlertModal ref="alertModal"/>
      <div class="content" v-if="showContent">
        <div class="top-detail pt-2">
          <div class="row m-0">
            <div class="col-4 p-0 center-title">
              <div class="row center-title m-0 display-in-row">
                <div class="col-2 p-0" v-if="booking.bookingDateTime != ''">
                  <div class="border-image">
                    <div class="border-image-number" :key="datekey">
                      {{ formatDate(booking.bookingDateTime, 'DD', 'YYYY-MM-DD HH:mm:ss') }}
                    </div>
                    <div class="border-image-text" :key="timeKey">
                      {{ formatDate(booking.bookingDateTime, 'MMM, YYYY hh:mm A', 'YYYY-MM-DD HH:mm:ss') }}
                    </div>
                    <!-- <div class="border-image-text" v-else :key="timeKey">{{formatDate(booking.bookingDateTime, 'MMM, YYYY', 'YYYY-MM-DD HH:mm:ss')}}</div> -->
                  </div>
                </div>
                <div class="col center-title ml-4">
                  {{ getLocationName() }}
                </div>
              </div>
            </div>
            <div class="col-3 center-title p-0">
              <div
                  v-if="this.singleCase.CaseID == '' || booking.claimantFullName != '' && booking.dateOfBirth != '' && booking.claimTypeName != ''">
                <div class="name" v-if="booking.claimantFullName">{{ booking.claimantFullName }}</div>
                <p v-if="booking.dateOfBirth != ''">D.O.B. {{ formatDate(booking.dateOfBirth, 'DD/MM/YYYY') }}</p>
                <!-- <p v-if="booking.commencementDate != ''">case Commenced:  {{formatDate(booking.commencementDate, 'DD/MM/YYYY')}}</p> -->
                <p v-if="booking.claimTypeName != ''">Type: {{ booking.claimTypeName }}</p>
              </div>
            </div>
            <div class="col p-0">
              <div class="row m-0">
                <div class="col-2 p-0">
                  <div class="rounded-image medium-rounded-image m-t-0 m-t-b" v-if="specialist.profileThumbnail">
                    <div class="profile-image-content"><img :src="specialist.profileThumbnail"/></div>
                  </div>
                  <div class="box-col" v-else>
                    <div class="rounded-image medium-rounded-image m-t-0 m-t-b">
                      <div class="profile-image-content notice-background"><s
                          class="text-initials">{{ getInitials(specialist) }}</s></div>
                    </div>
                  </div>
                </div>
                <div class="col center-title ml-4">
                  <div>
                    <div class="name">
                      {{ specialist.fullName }}
                      <img v-if="requiresTravel" class="icon-20" src="@/assets/images/travel_black_circle_icon.svg"/>
                      <img v-if="videoLinkAvailable == 2" class="icon-20 ml-2"
                           src="@/assets/images/video_black_icon.svg"/>
                    </div>
                    <div class="">
                      {{ getSpecialistInfo(specialist.practiceLocationId, specialist.locations) }}
                    </div>
                    <div class="">
                      {{ getBookingTypeById(this.booking.bookingTypeId) }}
                    </div>
                    <div v-if="booking.videoLinkTestStatus" class="is-icon"><img
                        src="@/assets/images/video_black_icon.svg"/></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box" v-if="displayBookingDetails">
          <div class="box-heading col-space-between">
            <div>Booking details</div>
          </div>
          <div class="box-body">
            <div class="box-row">
              <div class="box-col box-col-left required">Service Type</div>
              <div class="box-col box-col-right">
                <select
                    :disabled="isTPD"
                    v-model="booking.bookingTypeId"
                    @change="onChangeBookingType"
                    class="textbox w-100">
                  <option value="" hidden>Please choose ...</option>
                  <option v-for="type in allBookingTypes" :key="type.id" :value="type.id">
                    {{ type.name }}
                  </option>
                </select>
                <div v-if="hasError && !validateBookingType" class="text-danger">
                  Service Type is required.
                </div>
              </div>
            </div>
            <div class="box-row" v-if="booking.specialistAvailabilityId && showDelivery && !isTPD">
              <div class="box-col box-col-left required">Delivery Method</div>
              <div class="box-col box-col-right">
                <el-select v-model="booking.DeliveryMethodID" @change="changeMethod" class="w-75">
                  <el-option v-for="item in deliveryMethods" :value="item.value" :label="item.label" :key="item.value"
                             title="item.des"></el-option>
                </el-select>
                <div v-if="hasError && !validateDeliveryMethods" class="text-danger pl-2">Please select delivery
                  method
                </div>
              </div>
            </div>
            <div class="box-row" v-if="isTPD" >
              <div class="box-col box-col-left left-label required">Number of services</div>
              <div class="box-col box-col-right">
                <el-checkbox v-model="showMAS" @change="onChangeNum('MAS', $event)" class="default-checkbox tick">MAS</el-checkbox> <el-input-number v-show="showMAS" :controls="false" style="width: 50px" v-model="booking.MAS" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox v-model="showPIC" @change="onChangeNum('PIC', $event)" class="default-checkbox tick">PIC</el-checkbox> <el-input-number v-show="showPIC" :controls="false" style="width: 50px"  v-model="booking.PIC" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox v-model="showSHORT" @change="onChangeNum('ShortReport', $event)" class="default-checkbox tick">Short Report</el-checkbox> <el-input-number v-show="showSHORT" :controls="false" style="width: 50px"  v-model="booking.ShortReport" controls-position="right" step-strictly :min="1" :max="10"></el-input-number>
                <span>(<b>Please Note - </b>Short Report requests must be 5 questions or less).</span>
                <div v-if="hasError && !validateNumOfServices" class="text-danger pl-2">Please select at least one option and input the number</div>
              </div>
            </div>
            <div class="box-row" v-if="showClientContact">
              <div class="box-col box-col-left required">Client Contact</div>
              <div class="box-col box-col-right align-items-center">
                <el-select @change="changeMethod" placeholder="Select a Client" class="w-100"
                           v-model="booking.clientContactId" filterable
                           clearable>
                  <el-option v-for="contact in listContact" :key="contact.value" :value="contact.id"
                             :label="contact.name">{{ contact.name }}
                  </el-option>
                </el-select>
                <div class="text-danger mt-5" v-if="hasError && !validateCaseOwner">
                  Client Contact is required.
                </div>
              </div>
            </div>
            <div class="box-row" v-if="!booking.bookingTypeId == 6">
              <div class="box-col box-col-left">Will Accept Earlier Appointment</div>
              <div class="box-col box-col-right">
                <toggle-button @change="onChartToggleChange(1)" :color="{checked: '#56C568', unchecked: '#525252'}"
                               :width="40" :sync="true" :value="booking.willAcceptEarlier"/>
              </div>
            </div>
            <!-- ************************* -->

            <div class="box-row" v-if="!disableCaseField" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left required">Examinee Name</div>
              <div class="box-col box-col-right">
                <div v-if="!isEditName" @click="openAddNameModal" :key="nameKey" class="parent is-icon full-width-div">
                  <input type="text" disabled class="child px-3 placeholder-opacity"
                         placeholder="Please click here to enter the Examinee details"/>
                  <!-- <div class="text-danger" v-if="hasError && !validateClaimantName">
                    Please enter claimant's name
                  </div> -->
                </div>
                <span v-else :key="nameKey" @click="openAddNameModal" class="padding-left-10">
                  {{ this.booking.claimantFullName }}
                </span>
                <div class="text-danger" v-if="hasError && claimantNameError">
                  {{ claimantNameError }}
                </div>
              </div>
              <AddNameModal ref="addNameModal" @setName="setName"/>
            </div>
            <div class="box-row" v-if="!disableCaseField && !isTPD" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left">Examinee Salutation</div>
              <div class="box-col box-col-right">
                <el-select :disabled="disableCaseField" class="w-50" v-model="booking.Salutation" filterable clearable
                           placeholder="Examinee Salutation">
                  <el-option v-for="item in salutationList" :key="item.value" :value="item.value"
                             :label="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="box-row" v-if="!disableCaseField && !isTPD" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left">Examinee Preferred Name</div>
              <div class="box-col box-col-right">
                <input :disabled="disableCaseField" class="textbox referance" type="text"
                       placeholder="Examinee Preferred Name" v-model="booking.PreferredGivenName"/>
              </div>
            </div>
            <div class="box-row" v-if="!disableCaseField" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left">Date of Birth</div>
              <div class="box-col box-col-right box-col-center">
                <el-date-picker
                    class="w-50 date-of-birth"
                    :disabled="disableCaseField"
                    v-model="booking.dateOfBirth"
                    @change="checkReassessments"
                    format="dd/MM/yyyy"
                    :typeable="true"
                    placeholder="dd/mm/yyyy"></el-date-picker>
                <div v-if="hasError && !validateDateOfBirth" class="text-danger">Date of Birth is required.</div>
              </div>
            </div>
            <div class="box-row" v-if="!disableCaseField" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left required">Client Reference</div>
              <div class="box-col box-col-right">
                <input :disabled="disableCaseField" :class="hasError && referenceNumberError ? 'is-invalid' : ''" class="textbox referance" type="text" placeholder="Reference Number"
                       v-model="booking.ClientReference"/>
                <div v-if="hasError && referenceNumberError" class="text-danger">{{ referenceNumberError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left left-label required">State where the incident occurred</div>
              <div class="box-col box-col-right">
                <el-select v-model="booking.IncidentState">
                  <el-option v-for="state in states" :key="state.value" :value="state.value" :label="state.text">
                    {{ state.text }}
                  </el-option>
                  <el-option value="International" label="International">International</el-option>
                </el-select>
                <div v-if="hasError && !validateIncident" class="text-danger">Incident state is required.</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left" :class="disableCaseField ? 'disabled-element' : ''">Examinee Contact
                Details
              </div>
              <div class="box-col box-col-right">
                <div v-if="!isEditContact" @click="openManageContactDetails" class="parent is-icon full-width-div">
                  <input type="text" class="child placeholder-opacity" disabled
                         placeholder="Please click here to enter contact details"/>
                </div>
                <span v-else :key="contactKey" @click="openManageContactDetails" class="padding-left-10">
                  <span v-if="booking.claimantMobile" class='text-bold'>M: </span> {{ this.booking.claimantMobile }}
                  <span v-if="booking.claimantEmail" class='text-bold'>E: </span> {{ this.booking.claimantEmail }}
                  <span v-if="booking.claimantPhone1" class='text-bold'>P: </span> {{ this.booking.claimantPhone1 }}
                  <span v-if="booking.claimantPhone2" class='text-bold'>L: </span> {{ this.booking.claimantPhone2 }}
                </span>
                <div v-if="hasError && !validateAttendance && !disableCaseField" class="text-danger"
                     style="position: absolute; z-index: 1; top: 30px;">Contact Details are required.
                </div>
                <AddClientContactModal ref="addClientContactModal" :typrProps="'fromBooking'"/>
              </div>
            </div>
            <div class="box-row" v-if="!hideAttendance && !isTPD">
              <div class="box-col box-col-center box-col-left">Red Health to confirm attendance with Examinee</div>
              <div class="box-col box-col-right">
                <toggle-button class="pl-2" @change="onChartToggleChange(3)"
                               :color="{checked: '#56C568', unchecked: '#525252'}" :width="40" :sync="true"
                               :value="booking.redHealthMayContactClaimant"/>
              </div>
            </div>
            <div class="box-row" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left">Examinee Address</div>
              <div class="box-col box-col-right">
                <div v-if="!isEditAddress" class="parent is-icon full-width-div" @click="openManageAddress"
                     :key="addressKey">
                  <input class="child w-100 placeholder-opacity" disabled
                         placeholder="Please click here to update claimant's address"/>
                </div>
                <span class="padding-left-10" v-else @click="openManageAddress"
                      :key="addressKey">{{ booking.claimantFullAddress }}</span>
                <div class="is-icon right-float-element" @click="openManageAddress">
                </div>
                <AddClientAddressModal ref="addClientAddressModal" :isFromClient="true" :typrProps="'fromBooking'"/>
              </div>
            </div>
            <!--            <div v-if="booking.DeliveryMethodID === 2" class="box-row">-->
            <!--              <div class="box-col box-col-left left-label">Video Link URL</div>-->
            <!--              <div class="box-col box-col-right">-->
            <!--                <el-input type="text" maxlength="255" class="video-link-url  w-75" v-model="booking.VideoLinkURL" placeholder="Video Link URL" />-->
            <!--              </div>-->
            <!--            </div>-->
<!--            <div v-if="booking.DeliveryMethodID === 2 && !isTPD" :class="booking.id ? 'disabled-element' : ''" class="box-row">-->
<!--              <div class="box-col box-col-left left-label">Examinee Location for VideoLink</div>-->
<!--              <div class="box-col box-col-right">-->
<!--                <input :disabled="booking.id" type="text" class="px-3" maxlength="255" v-model="booking.ClaimantLocation"-->
<!--                       placeholder="Examinee Location for VideoLink"/>-->
<!--              </div>-->
<!--            </div>-->
            <div v-if="booking.DeliveryMethodID === 2 && !isTPD" class="box-row">
              <div class="box-col box-col-left left-label required">Examinee State During Booking</div>
              <div class="box-col box-col-right">
                <div class="pl-2">Which state will your claimant be located in for the appointment?</div>
                <el-cascader
                    popper-class="search-no-scroll-panel"
                    style="min-width: 250px"
                    v-model="bookingExamineeStatus"
                    :options="options"
                    @change="handleChange"></el-cascader>
                <span v-if="timeZoneValue" class="ml-2">{{ timeZoneValue }}</span>
                <div v-if="hasError && !validateState" class="text-danger pl-2">State is required.</div>
                <div v-if="hasError && examineeLocationError" class="text-danger pl-2">{{ examineeLocationError }}</div>
              </div>
            </div>
            <!--            <div class="box-row">-->
            <!--              <div  class="box-col box-col-left">On behalf of</div>-->
            <!--              <div class="box-col box-col-right">-->
            <!--                <input class="textbox behalf" type="text" placeholder="On behalf of" v-model="booking.onBehalfOf" />-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="box-row">
              <div class="box-col box-col-left">Date of Accident/Event</div>
              <div class="box-col box-col-right box-col-center" style="display: flex;">
                <datepicker
                    class="w-50 accient-date"
                    format="dd/MM/yyyy"
                    :typeable="true"
                    :disabled="booking.overPeriodofTime"
                    placeholder="dd/mm/yyyy"
                    @selected="changeDate"
                    v-model="booking.accidentDate"></datepicker>
                <div style="display: flex;align-items: center; padding-left: 10px;">
                  <toggle-button @change="onChartToggleChange(4)" class="togglePeriodOfTime"
                                 :color="{checked: '#56C568', unchecked: '#525252'}" :width="40" :sync="true"
                                 :value="booking.overPeriodofTime"/>
                  Over a period of time
                </div>
              </div>
            </div>
            <div class="box-row" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left" :class="isTPD ? '' : 'required'">Referral Type</div>
              <div class="box-col box-col-right">
                <el-select :disabled="disableCaseField || isTPD" v-model="booking.ClaimTypeID"
                           @change="changedClaimantType($event)"
                           :class="hasError && !validateTypeOfClaim ? 'is-invalid' : ''" class="w-50"
                           popper-class="search-popup-longer">
                  <el-option v-for="claimType in claimTypes" :key="claimType.id" :value="claimType.id"
                             :label="claimType.name">{{ claimType.name }}
                  </el-option>
                </el-select>
                <div class="text-danger" v-if="hasError && !validateTypeOfClaim">
                  Please choose type of claim
                </div>
              </div>
            </div>
            <div class="box-row" style="padding: 0 20px; color: #000">
              Please indicate the condition or injuries to be assessed by the Medical Expert using one or more of the 3 fields below:
            </div>
            <div class="box-row" style="border-top: 0">
              <div class="box-col box-col-left">Affected Body Areas</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input
                    class="pr-10"
                    v-model="bodyAreaTag"
                    :tags="bodyAreaTags"
                    placeholder="Add Affected Body Areas"
                    :autocomplete-items="filteredBodyAreaItems"
                    @tags-changed="(newTags) => (bodyAreaTags = newTags)"
                    @focus="openDigram()"
                />
              </div>
              <div @click="openBodyDiagram" class="center-item">
                <img src="@/assets/images/choose.svg" alt="" class="right-element align-self-center is-icon pr-3"/>
              </div>
              <AddBodyDiagramModal style="top: 0px" ref="addBodyDiagramModal"/>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Other Body Areas</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input
                    v-model="otherBodyAreaTag"
                    :tags="otherBodyAreaTags"
                    :placeholder="this.booking.caseId == '' ? 'Add Other Body Areas':''"
                    @tags-changed="(newTags) => (otherBodyAreaTags = newTags)"/>
                <div v-if="hasError && otherBodyAreasError" class="text-danger">{{ otherBodyAreasError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Conditions</div>
              <div class="box-col box-col-right box-col-center">
                <el-select placeholder="Add Conditions" class="w-100" v-model="booking.PersonConditions" multiple
                           clearable filterable>
                  <el-option v-for="item in personConditions" :value="item.value" :label="item.text"
                             :key="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="box-row"
                 v-if="booking.bookingTypeId != 6 && booking.bookingTypeId != 7 && booking.bookingTypeId != 8 && !isTPD">
              <div class="box-col box-col-left">Interpreter Required?</div>
              <div class="box-col box-col-right">
                <toggle-button @change="onChartToggleChange(2)" :color="{checked: '#56C568', unchecked: '#525252'}"
                               :width="40" :sync="true" :value="booking.interpreterRequired"/>
                <el-checkbox v-if="booking.interpreterRequired" class="ml-3" v-model="booking.OrganizeRequired"
                             size="large" @change="changeFilter">Red Health to organize
                </el-checkbox>
              </div>
            </div>
            <div class="box-row" v-if="booking.interpreterRequired && !booking.OrganizeRequired">
              <div class="box-col box-col-left">
                Interpreter Details
              </div>
              <div class="box-col box-col-right">
                <div @click="openInterpreterDetail" :readonly="true" type="text" class="px-3"
                       v-html="getInterpreterDetail()" placeholder="Click to add interpreter details if required"/>
                <div v-if="hasError && !validateInterpreter" class="text-danger">Interpreter detail is required.</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Send Report To</div>
              <div class="box-col box-col-right">
                <el-select @change="selectedSendTo" class="w-100" v-model="booking.reportTo" filterable clearable>
                  <el-option v-for="contact in originalClientContacts" :key="contact.value" :value="contact.value"
                             :label="contact.name">{{ contact.name }}
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="showSendReportToOther" class="box-row">
              <div class="box-col box-col-left">Send report Email</div>
              <div class="box-col box-col-right">
                <input :class="hasError && sendEmailError ? 'is-invalid' : ''" class="textbox" type="text" placeholder="Send report to this email address"
                       v-model="booking.reportToText"/>
                <div v-if="hasError && sendEmailError" class="text-danger">{{ sendEmailError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Bill to</div>
              <div class="box-col box-col-right">
                <el-select @change="selectedBillTo" class="w-100" v-model="booking.billTo" filterable clearable>
                  <el-option v-for="contact in originalClientContacts" :key="contact.value" :value="contact.value"
                             :label="contact.name">{{ contact.name }}
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="showBillToEmail" class="box-row">
              <div class="box-col box-col-left">Bill to Email</div>
              <div class="box-col box-col-right">
                <input :class="hasError && billEmailError ? 'is-invalid' : ''" class="textbox" type="text" placeholder="Bill to this email address"
                       v-model="booking.billToText"/>
                <div v-if="hasError && billEmailError" class="text-danger">{{ billEmailError }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box" v-if="displayBookingDetails">
          <div class="box-heading tab">
            <div class="tab-heading px-5  notes-heading tab-selected" @click="openNotes">Notes</div>
            <div class="tab-heading px-5 files-heading" @click="openFiles">Files</div>
            <div class="col-space-between is-icon right-float-element">
              <v-btn v-if="showAddNote" class="add-icon mr-3" dark @click="openAddNoteModal">Add New</v-btn>
              <v-btn v-if="!showAddNote && !isTPD" class="add-icon mr-3" dark @click="openFilesBox">Add New</v-btn>
              <AddNoteModal ref="addNoteModal" :bookingProps="booking"/>
            </div>
          </div>
          <div class="box-body notes-content hidden-element">
            <div class="box-row overflow-hidden" v-for="(note, index) in booking.bookingNotes" :key="index">
              <div class="box-col box-col-left">{{ decodeURIComponent(user.name) }}</div>
              <div class="box-col box-col-left">
                {{ formatDate(note.NoteDateTime, 'DD/MM/YYYY hh:mm A', "YYYY-MM-DD HH:mm:ss.ssssss") }}
              </div>
              <div @click="editNote(index)" class="box-col box-col-right box-col-long col-center-content text-break"
                   style="max-width: 60%;">
                {{ note.Note }}
              </div>
              <div v-if="booking.bookingNotes.length > 0" class="col col is-icon center-title" style="max-width: 10%;"
                   @click="deleteNote(note.id, index)"><img class="right-align" src="@/assets/images/delete_icon.svg"/>
              </div>
            </div>
          </div>

          <div class="box-body files-content hidden-element">
            <div>
              <div>
                <table class="table">
                  <thead>
                  <tr>
                    <th style="width:15%" class="long-text">
                      File Type
                    </th>
                    <th style="width:50%" class="long-text">
                      File Name
                    </th>
                    <th style="width:15%" class="long-text">
                      Uploaded By
                    </th>
                    <th style="width:10%" class="long-text">
                      Status
                    </th>
                    <th style="width:10%" class="icon-col">
                      <div class="icon-group">&nbsp;</div>
                    </th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="content-scroll-y" style="height:auto;max-height:460px;">
                <table class="table remove-min-height">
                  <tbody>
                  <tr v-for="(file, index) in fileParams" :key="index" class="py-0">
                    <td style="width:15%" class="long-text">
                      <el-select :disabled="isTPD" v-model="file.FileTypeID" placeholder="Select File Type" class="w-100"
                                 @change="changeFileType($event, index)">
                        <el-option v-for="fileType in fileTypes" :value="fileType.FileTypeID" :key="fileType.FileTypeID"
                                   :label="fileType.FileTypeName">{{ fileType.FileTypeName }}
                        </el-option>
                      </el-select>
                    </td>
                    <td style="width:50%" class="long-text">{{ file.FileName }}</td>
                    <td style="width:15%" class="long-text">{{ file.UploadedByName }}</td>
                    <td style="width:10%" class="long-text">
                      <span style="padding-left: 10px;">{{ file.FileStatus ? 'Final' : 'Draft' }}</span>
                    </td>
                    <td style="width:10%; vertical-align: middle;" @click="deleteFile(index)" class="long-text">
                      <div class="icon-group d-flex justify-content-center"><img src="@/assets/images/delete_icon.svg"/>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="!isTPD" class="file-upload-area border-gray-300 mt-5" @dragover="dragover" @dragleave="dragleave" @drop="drop">
              <input
                  type="file"
                  multiple
                  name="fields[assetsFieldHandle][]"
                  id="assetsFieldHandle"
                  class="w-px h-px opacity-0 overflow-hidden absolute"
                  @change="onChange"
                  ref="file"
                  accept=""/>
              <label for="assetsFieldHandle"
                     class="block cursor-pointer d-flex justify-content-center flex-column align-items-center">
                <div>Drop files in this area or <span style="text-decoration:underline"
                                                      class="is-icon">click here</span> to upload files.
                </div>
                <div>Files over 200MB in file size may cause errors. If you need to upload files of this size, please
                  contact us on 1300 100 733
                </div>
              </label>
            </div>
          </div>
        </div>

        <div v-if="displayBookingDetails" class="box-row item-right box-col-next">
          <div>
            <v-btn dark @click="tapNext()">Next</v-btn>
          </div>
        </div>
        <div class="box" v-if="displayBookingSummery" :key="summaryKey">
          <div class="box-heading col-space-between">
            <div>Booking Summary</div>
          </div>
          <div class="box-body">
            <div class="box-row" v-if="isTPD">
              <div class="box-col box-col-left left-label">Number of services</div>
              <div class="box-col box-col-right">
                <el-checkbox disabled v-model="showMAS" class="default-checkbox tick">MAS</el-checkbox> <el-input-number disabled v-show="showMAS" :controls="false" style="width: 50px" v-model="booking.MAS" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox disabled v-model="showPIC" class="default-checkbox tick">PIC</el-checkbox> <el-input-number disabled v-show="showPIC" :controls="false" style="width: 50px"  v-model="booking.PIC" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox disabled v-model="showSHORT"  class="default-checkbox tick">Short Report</el-checkbox> <el-input-number disabled v-show="showSHORT" :controls="false" style="width: 50px"  v-model="booking.ShortReport" controls-position="right" step-strictly :min="1" :max="10"></el-input-number>
              </div>
            </div>

            <div class="box-row" v-if="!this.hideOtherStatus && !isTPD">
              <div class="box-col box-col-left">Do you need a phone call with the doctor after the appointment?
                (additional charges may apply)
              </div>
              <div class="box-col box-col-right">
                <toggle-button @change="onChartToggleChange(7)" :color="{checked: '#56C568', unchecked: '#525252'}"
                               :width="40" :sync="true" :value="booking.callClientAfterAppointment"/>
              </div>
            </div>
            <div class="box-row" v-if="!this.hideOtherStatus && !hideAttendance && !isTPD">
              <div class="box-col box-col-left">Red Health to confirm attendance with Examinee</div>
              <div class="box-col box-col-right">
                <toggle-button @change="onChartToggleChange(3)" :color="{checked: '#56C568', unchecked: '#525252'}"
                               :width="40" :sync="true" :value="booking.redHealthMayContactClaimant"/>
              </div>
            </div>
            <div class="box-row" v-if="client && client.paymentDeferralOption">
              <div class="box-col box-col-left">Is Fee Deferral required?</div>
              <div class="box-col box-col-right">
                <toggle-button @change="onChartToggleChange(9)" :color="{checked: '#56C568', unchecked: '#525252'}"
                               :width="40" :sync="true" :value="booking.feeDeferralRequired"/>
              </div>
            </div>
            <div class="box-row" v-if="booking.id">
              <div class="box-col box-col-left required">Reason for Reschedule</div>
              <div class="box-col box-col-right">
                <textarea v-model="reason" placeholder="Enter Reschedule reason" rows="1" maxlength="100"/>
                <div class="text-danger" v-if="hasError && !validateReschedule">
                  Please enter the Reschedule reason
                </div>
              </div>
            </div>
            <div v-if="booking.bookingTypeId != 6 && booking.bookingTypeId != 8 && !hideWarning"
                 class="box-row box-warning">
              <div class="box-col Warning-left">
                Warning: non-attendance by the claimant will attract a fee.
              </div>
            </div>
          </div>
        </div>
        <div class="box-row item-right" v-if="displayBookingSummery">
          <div style="padding-right:20px">
            <v-btn :disabled="disableButton" class="btn-light" @click="tapEdit()">Back</v-btn>
          </div>
          <div>
            <v-btn :disabled="disableButton" dark @click="tapSubmit()">Book</v-btn>
          </div>
        </div>

        <div class="aler-green alert alert-success hidden-element" style="min-height: 110px;">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
          <div v-if="showAddCalender" style="display: flex; padding-top: 8px;">
            <div class="icon-group center-element" style="left: 60%;">
              <!-- <v-btn class="alert-button"style="min-width: 210px;"  @click="downloadToCalender()">Add to my Calendar</v-btn> -->
              <v-btn class="alert-button" @click="handleClose()">Ok</v-btn>
            </div>
          </div>
        </div>
        <div class="alert-waitlisted alert alert-success hidden-element">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
        </div>
        <div class="alert alert-danger general-alert-danger hidden-element">
          <a class="close" title="close">×</a>
          <b>Error:</b> {{ errorMessage }}
        </div>
        <div style="width: fit-content; left: 20%; top: 70%" class="tentative-alert alert alert-warning hidden-element">
          <a class="close" title="close" @click="closeDialog">×</a>
          <b>Warning:</b> {{ errorMessage }}
        </div>

        <div class="rescheduled-alert alert alert-warning hidden-element">
          <a class="close" title="close">×</a>
          <b>Warning:</b> {{ errorMessage }}
          <v-btn class="alert-button ml-4" @click="backToHome()">Ok</v-btn>
        </div>

        <div class="confirm alert alert-warning hidden-element">
          <div class="icon-group center-element" style="left: 60%;">
            <v-btn class="alert-button" @click="tapButtonConfirmation(false)">New Case</v-btn>
            <v-btn class="alert-button" @click="tapButtonConfirmation(true)">Existing Case</v-btn>
          </div>
          <a class="close" title="close" @click="tapButtonConfirmation(false)">×</a>
          A case for {{ this.booking.claimantFullName + ' ' + formatDate(this.booking.dateOfBirth, 'DD/MM/YYYY') }}
          already exists. Create a new case or attach to existing?
        </div>

        <div class="row align-items-center" style="padding: 50px 0px;" v-if="displayBanner && displayBookingSummery"
             :key="bannerKey">
          <div class="col box-ads">
            <img src="@/assets/images/payment_deferral_promo.jpg"/>
          </div>
        </div>
        <AdditionalBookingModal ref="additionalBookingModal"/>
      </div>
    </div>
    <el-dialog title="Warning" :visible.sync="confirmDialog"
               width="50%">
      <div v-if="currentParam">
        <div style="word-break: break-word">
          {{ `The new appointment slot can be either a VideoLink assessment, or an In Person assessment at ${getLocationName()}. Please select which type of appointment you would like:` }}
        </div>
        <el-select style="margin-top: 20px; width: 400px" placeholder="Please select a type"
                   v-model="currentParam.BookingTypeID" @change="onChangeSelect">
          <el-option :value="2" label="Independent Medical Examination">Independent Medical Examination</el-option>
          <el-option :value="4" label="Independent Medical Examination By Video">Independent Medical Examination By
            Video
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="confirmDialog = false; currentParam = null; tapEdit()">Cancel</el-button>
    <el-button type="primary" @click="confirmChange">OK</el-button>
  </span>
    </el-dialog>
    <Chat/>
    <el-dialog title="Select TimeZone" :visible.sync="showTimeZone">
      <div>
        <el-select filterable v-model="timeZoneValue">
          <el-option v-for="item in timeZones" :key="item" :value="item" :label="item"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
    <v-btn dark class="white-button" @click="cleanData">Cancel</v-btn>
    <el-button type="primary" @click="showTimeZone = false;">OK</el-button>
  </span>
    </el-dialog>
    <InterpreterDetailDialog ref="interpreterModal" :user="user" @clickSave="handleSaveInterpreterDetail"/>
    <DuplicateCaseModal :dialogVisible="dialogVisible" :hasToChooseCase="hasToChooseCase" @selectCase="selectCase"
                        :result="result" @closeModal="closeModal"/>
    <TPDFiles :client="true" :fileCountList="fileCountList" :tpdFilesDialog="tpdFilesDialog" @cancelDialog="tpdFilesDialog = false" @next="handleFiles" />
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import InterpreterDetailDialog from "@/components/dialog/InterpreterDetailDialog.vue";
import Navigation from '@/components/Navigation'
import ClientBookingMenu from '@/components/ClientBookingMenu'
import Header from '@/components/Header'
import Chat from '@/components/Chat'
import AddNoteModal from '@/components/AddNoteModal'
import AlertModal from '@/components/AlertModal'
import AddNameModal from '@/components/AddNameModal'
import AddClientContactModal from '@/components/AddClientContactModal'
import AddClientAddressModal from '@/components/AddClientAddressModal'
import AddBodyDiagramModal from '@/components/AddBodyDiagramModal'
import AdditionalBookingModal from '@/components/AdditionalBookingModal'
import DuplicateCaseModal from '@/components/case/DuplicateCaseModal'
import TPDFiles from "./TPDFiles.vue";

export default {
  name: 'ManageBooking',
  components: {
    TPDFiles,
    Navigation,
    ClientBookingMenu,
    Header,
    Chat,
    DuplicateCaseModal,
    AddNoteModal,
    AlertModal,
    AddNameModal,
    AddClientContactModal,
    AddClientAddressModal,
    AddBodyDiagramModal,
    AdditionalBookingModal,
    InterpreterDetailDialog
  },
  data() {
    return {
      fileCountList: [0, 0, 0, 0],
      showSHORT: false,
      showMAS: false,
      showPIC: false,
      tpdFilesDialog: false,
      client: {},
      caseChange: false,
      options: [],
      bookingExamineeStatus: [],
      timeZones: [],
      timeZoneValue: null,
      showTimeZone: false,
      deliveryMethods: [],
      showDelivery: false,
      currentParam: null,
      result: [],
      hasToChooseCase: false,
      dialogVisible: false,
      editingIndex: null,
      salutationList: utilities.initSalutation(),
      booking: utilities.initBooking(),
      originalBooking: utilities.initBooking(),
      dateOfBirth: "",
      commencemenrDate: "",
      dateAccident: "",
      fillOrder: "",
      currentValue: '',
      placeholder: "Add",
      successMessage: "",
      errorMessage: "",
      hasError: false,
      bookingTypesLocal: utilities.getCreateSpecialistsBookingTypes(),
      isEditContact: false,
      isEditAddress: false,
      toggleEarlierAppointment: false,
      toggleWithClaimant: false,
      togglePeriodOfTime: false,
      toggleOTFCE: false,
      togglePrivate: false,
      toggleAfterAppointment: false,
      toggleAttendance: false,
      displayBanner: false,
      displayBookingSummery: false,
      displayBookingDetails: true,
      showWarning: false,
      isEditName: false,
      showAddCalender: true,
      loaded: false,
      showBookingStatus: true,
      hideOtherStatus: true,
      claimFocus: false,
      isWaitlisted: false,
      showContent: true,
      hideAttendance: false,
      hideWarning: false,
      showMsg1: false,
      showMsg2: false,
      disableButton: false,
      requiresTravel: false,
      showAddNote: true,
      disableCaseField: false,
      isMultipleLocation: false,
      isSameLocation: false,
      videoLinkAvailable: 1,
      newBookingId: 0,
      reason: '',
      qualificationId: '',
      originalSpecialistId: '',
      originalBookingDateTime: '',
      locations: [],
      originalClientContacts: [],
      bookingProps: [],

      bodyAreaTag: "",
      otherBodyAreaTag: "",
      personConditionTag: "",
      bodyAreas: [],
      bodyAreaTags: [],
      otherBodyAreaTags: [],
      deletedBodyTags: [],
      personConditions: [],
      personConditionTags: [],
      deletedConditionTags: [],
      // Validate Dates
      isValidDateOfBirth: true,
      isValidAccidentDate: true,
      isFromSpecialist: false,
      hideInfo: false,
      showClientContact: false,
      originalClaimantConfirmed: '',

      clientContacts: [],
      claimTypes: [],
      singleCase: [],
      filelist: [],
      fileParams: [],
      specialist: [],
      addedBodyArea: [],
      addedConditions: [],
      allBookingTypes: [],
      specialistTimes: [],
      availableTimes: [],
      cases: [],
      searchCases: [],
      minimumAppointment: [],
      bookingLog: [],
      videoLinkLocation: [],
      relatedServices: [],
      states: [],

      showBillToEmail: false,
      showSendReportToOther: false,
      listContact: [],
      originalSpecialistFullName: '',
      specialistAvailabilityId: 0,
      addressKey: 0,
      noteKey: 0,
      nameKey: 0,
      confirmDialog: false,
      contactKey: 1,
      datekey: 2,
      timeKey: 3,
      selected: 0,
      summaryKey: 1,
      selectedCount: 0,
      timer: null,
      bannerKey: 1,
      values: [
        {label: 'Confirmed', value: 3, text: 'This will lock in the appointment you have selected'},
        {
          label: 'Tentative',
          value: 2,
          text: 'This will hold the appointment for you for 24 hours. If you haven\'t confirmed the booking before this time, the appointment will be released, and someone may book that appointment.'
        },
      ],
      fileTypes: [],
    }
  },
  watch: {
    booking: {
      handler(value) {
        if (this.loaded) {
          this.$store.dispatch("setNewObject", value)
        }
      },
      deep: true,
    },
    bodyAreaTags: {
      handler(value) {
        localStorage.setItem('storedBodyArea', JSON.stringify(this.bodyAreaTags))
      },
      deep: true,
    },
    otherBodyAreaTags: {
      handler(value) {
        localStorage.setItem('storedOtherBodyArea', JSON.stringify(this.otherBodyAreaTags))
      },
      deep: true,
    },
    personConditionTags: {
      handler(value) {
        localStorage.setItem('storedPersonCondition', JSON.stringify(this.personConditionTags))
      },
      deep: true,
    },
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    isTPD() {
      return this.booking.bookingTypeId === 19
    },
    validateNumOfServices() {
      if(this.booking.bookingTypeId === 19 && !this.showSHORT && !this.showMAS && !this.showPIC) {
        return false
      }
      if((this.showSHORT && !this.booking.ShortReport) || (this.showMAS && !this.booking.MAS) || ( this.showPIC && !this.booking.PIC)) {
        return false
      }
      return true
    },
    validateDeliveryMethods() {
      if (utilities.bookingTypeWithDeliveryMethods(this.booking.bookingTypeId)) {
        return this.booking.DeliveryMethodID
      }
      return true
    },
    validateIncident() {
      return this.booking.IncidentState
    },
    validateReferenceNumber() {
      return !this.referenceNumberError
    },
    referenceNumberError() {
      return utilities.getAdminBookingClientReferenceError(this.booking.ClientReference)
    },
    validateInterpreter() {
      if (this.booking.interpreterRequired && !this.booking.OrganizeRequired && !this.booking.InterpreterName) {
        return false
      }
      return true
    },
    validateCaseOwner() {
      if (this.booking.clientContactId === null || this.booking.clientContactId === undefined || this.booking.clientContactId === "") {
        return false
      }
      return true
    },
    validateBookingType() {
      if (!this.booking.bookingTypeId) {
        return false;
      }
      return true;
    },
    validateSendEmail() {
      return !this.sendEmailError
    },
    sendEmailError() {
      if (!this.showSendReportToOther) {
        return ''
      }
      return utilities.getClientContactEmailError(this.booking.reportToText, 'Send report email', false)
    },

    validateBillEmail() {
      return !this.billEmailError
    },
    billEmailError() {
      if (!this.showBillToEmail) {
        return ''
      }
      return utilities.getClientContactEmailError(this.booking.billToText, 'Bill to email', false)
    },
    filteredBodyAreaItems() {
      return this.bodyAreas.filter((i) => {
        return i.text.toLowerCase().indexOf(this.bodyAreaTag.toLowerCase()) !== -1
      })
    },

    filteredPersonConditionsItems() {
      return this.personConditions.filter((i) => {
        return i.text.toLowerCase().indexOf(this.personConditionTag.toLowerCase()) !== -1
      })
    },

    validateDateOfBirth() {
      if (this.booking.dateOfBirth == '') {
        return false
      }
      return true
    },

    validateAttendance() {
      if (!utilities.bookingTypeWithAvailability(this.booking.bookingTypeId)) {
        return true
      } else if (this.disableCaseField) {
        return true
      } else if (this.booking.claimantConfirmed && this.booking.claimantEmail == '' && this.booking.claimantPhone1 == '' && this.booking.claimantPhone2 == '' && this.booking.claimantMobile == '') {
        return false
      }
      return true
    },

    validateTypeOfClaim() {
      if (!this.booking.ClaimTypeID) {
        return false
      }
      return true
    },

    validateClaimantName() {
      return !this.claimantNameError
    },
    claimantNameError() {
      const firstErr = utilities.getClientContactPersonNameError(this.booking.claimantFirstName, 'First name')
      if (firstErr) {
        return firstErr
      }
      return utilities.getClientContactPersonNameError(this.booking.claimantSurname, 'Surname')
    },

    validateReschedule() {
      if (this.booking.id && !this.reason) {
        return false
      }
      return true
    },

    validateState() {
      if (this.booking.DeliveryMethodID === 2 && !this.isTPD && (!this.bookingExamineeStatus || this.bookingExamineeStatus.length === 0 || !this.bookingExamineeStatus[0])) {
        return false
      }
      return true
    },
    examineeLocationError() {
      if (this.booking.DeliveryMethodID !== 2) {
        return ''
      }
      return utilities.getExamineeLocationForVideoLinkError(this.booking.ClaimantLocation)
    },
    otherBodyAreasError() {
      return utilities.getAdminBookingOtherBodyAreasError(this.otherBodyAreaTags)
    },
  },

  methods: {
    onChangeNum(name, value) {
      if (value) {
        this.booking[name] = 1
        this.$set(this.booking, name, 1)
      } else {
        this.$set(this.booking, name, 0)
      }
    },
    handleFiles(files) {
      this.tpdFilesDialog = false
      this.filelist = [...this.filelist, ...files]
      this.showAddNote = false
      $('.notes-content').hide()
      $('.tab-selected').removeClass('tab-selected')
      $('.files-heading').addClass('tab-selected')
      $('.files-content').show()
      //this.booking.bookingFiles = []
      var i = 0
      const fileTypes = ['MAS Template', 'PIC Template', 'Letter of Instruction', 'Brief']
      files.map((e, index) => {
            e && e.forEach((x) => {
              let file = this.fileParams.filter((y) => y.FileName === x.name)
              if (file.length === 0) {
                this.fileParams.push({
                  FileName: x.name,
                  FileTypeID: this.fileTypes.find((x) => x.FileTypeName === fileTypes[index]).FileTypeID,
                  UploadedBy: this.user.id,
                  MimeType: x.type,
                  FileStatus: 1,
                  UploadedByName: this.user.name,
                  DateUploaded: window.moment().format("YYYY-MM-DD HH:mm:ss"),
                  isHide: false,
                  index: i,
                  file: x
                })
              }
            })
      })
    },
    async checkReassessments() {
      if (!this.booking.bookingDateTime && !this.booking.bookingTypeId === 2 && !this.booking.bookingTypeId === 22) {
        return
      }
      if(this.booking.id) {
        return
      }
      let p = {
        BookingDateTime: this.booking.bookingDateTime,
        SpecialistID: this.booking.specialistId,
        ClaimantFirstName: this.booking.claimantFirstName,
        ClaimantSurname: this.booking.claimantSurname,
        DateofBirth: window.moment(this.booking.dateOfBirth).format('YYYY-MM-DD'),
        ClientID: this.user.clientId,
      }
      const result = await utilities.checkReassessments(p)
      this.booking.Reassessment = result.Reassessment
    },
    changeMethod() {
      this.$forceUpdate()
    },
    handleSaveInterpreterDetail(obj) {
      this.booking = {...this.booking, ...obj}
    },
    openInterpreterDetail() {
      if (this.booking.Status.StatusID === 6) return
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterName', _.cloneDeep(this.booking.InterpreterName))
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterCompanyName', _.cloneDeep(this.booking.InterpreterCompanyName))
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterContactNumber', _.cloneDeep(this.booking.InterpreterContactNumber))
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterContactEmail', _.cloneDeep(this.booking.InterpreterContactEmail))
      this.$refs.interpreterModal.visible = true
    },
    changeFilter(v) {
      if (v) {
        this.booking.interpreterDetails = ''
      }
    },
    onChangeBookingType(e) {
      this.$forceUpdate()
    },
    closeDialog() {
      utilities.hideAlert(".tentative-alert")
    },
    getInitials(specialist) {
      var initials = ""
      if (specialist.firstName) {
        initials = specialist.firstName.substring(0, 1)
      }

      if (specialist.lastName) {
        initials = initials + specialist.lastName.substring(0, 1)
      }
      return initials
    },

    defineClearButton() {
      $(".report-to-selecter input").after("<div class='dropdown-input-clear'></div>")
      $(".report-to-selecter .dropdown-input-clear").click((e) => {
        this.$refs.dropdownEmailSendTo.searchFilter = ""
        this.booking.reportTo = ""
        this.showSendReportToOther = false
      })

      $(".bill-to-selecter input").after("<div class='dropdown-input-clear'></div>")
      $(".bill-to-selecter .dropdown-input-clear").click((e) => {
        this.$refs.dropdownEmailBillTo.searchFilter = ""
        this.booking.billTo = ""
        this.showBillToEmail = false
      })
    },

    selectedContact(item) {
      this.$set(this.booking, 'caseOwner', item.id)
    },

    getInterpreterDetail() {
      let str = ''
      if (this.booking.InterpreterName) {
        str += '<b>N: </b>' + this.booking.InterpreterName + '&nbsp'
      }
      if (this.booking.InterpreterCompanyName) {
        str += '<b>C: </b>' + this.booking.InterpreterCompanyName + '&nbsp'
      }
      if (this.booking.InterpreterContactNumber) {
        str += '<b>P: </b>' + this.booking.InterpreterContactNumber + '&nbsp'
      }
      if (this.booking.InterpreterContactEmail) {
        str += '<b>E: </b>' + this.booking.InterpreterContactEmail + '&nbsp'
      }
      if (str === '') {
        str += '<span style="color: #D5D5D5">Click to Add Detail</span'
      }
      console.log(str)
      return str
    },
    getSurrogateDetail() {
      let str = ''
      if (this.booking.SurrogateAssessorName) {
        str += '<b>N: </b>' + this.booking.SurrogateAssessorName + '&nbsp'
      }
      if (this.booking.SurrogateAssessorCompanyName) {
        str += '<b>C: </b>' + this.booking.SurrogateAssessorCompanyName + '&nbsp'
      }
      if (this.booking.SurrogateAssessorContactNumber) {
        str += '<b>P: </b>' + this.booking.SurrogateAssessorCompanyName + '&nbsp'
      }
      if (this.booking.SurrogateAssessorContactEmail) {
        str += '<b>E: </b>' + this.booking.SurrogateAssessorContactEmail + '&nbsp'
      }
      if (this.booking.SurrogateAssessorCost) {
        str += '<b>C: </b>' + this.booking.SurrogateAssessorCost + '&nbsp'
      }
      if (str === '') {
        str += '<span style="color: #D5D5D5">Click to Add Detail</span'
      }
      return str
    },

    filterReportTo(text) {
      this.listClients = this.originalClientContacts.filter((item) => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1);
    },

    selectAccientDate() {
      this.booking.overPeriodofTime = false
    },

    changeAccientDate() {
      setTimeout(() => {
        this.isValidAccidentDate = this.validateAccidentDate()
      }, 200)
    },

    selectedBillTo(item) {
      if (item === 'Other') {
        this.showBillToEmail = true
        this.billToText = ""
      } else {
        this.showBillToEmail = false
      }
    },

    selectedSendTo(item) {
      if (item === 'Other') {
        this.showSendReportToOther = true
        this.reportToText = ""
      } else {
        this.showSendReportToOther = false
      }
    },
    updateConditions(newTags) {
      if (this.$refs.conditions.newTag.length == 0) newTags.pop()
      this.personConditionTags = newTags
    },

    changeDate() {
      this.booking.overPeriodofTime = false
    },

    setBookingNoteAndAction(params) {
      this.booking.bookingNotes[this.editingIndex] = params
      this.$forceUpdate()
    },

    editNote(index) {
      let note = this.booking.bookingNotes[index]
      note = JSON.parse(JSON.stringify(note))
      note.note = note.Note
      this.editingIndex = index
      if ((note.userId == this.user.id) || !note.userId) {
        this.$refs.addNoteModal.internalOnly = 0
        this.$refs.addNoteModal.isEditClient = true
        this.$refs.addNoteModal.editCurrentNote(note)
        this.$refs.addNoteModal.handleModal()
      }
    },

    getClaimantTypeName(id) {
      var type = ''
      if (id != undefined || id != '' && this.claimTypes.length == 0) {
        return
      }
      if (id) {
        type = this.claimTypes.find((x) => x.id == id).name
      }
      return type
    },

    changedClaimantType(event) {
      var item = this.claimTypes.find((x) => x.id == event)
      this.booking.claimTypeName = item.name
    },

    changedBookingStatus(e) {
      if (e == 0) {
        this.selected = 0
        this.booking.bookingStatus = 3
        this.booking.bookingStatusName = "Booked"
      } else if (e == 1) {
        this.selected = 1
        this.booking.bookingStatus = 2
        this.booking.bookingStatusName = "Tentative"
      } else {
        this.booking.bookingStatus = 1
        this.booking.bookingStatusName = "Draft"
      }
    },

    onChangeBookingDate(e) {
      this.availableTime = []
      this.booking.bookingTime = ""
      var times = this.specialistTimes.find((x) => x.date == event.target.value)
      if (times) {
        times.slots.map((x) => {
          if (x.status == "A") {
            this.availableTime.push(x)
          }
        })
      }
    },

    onChangeTime(e) {
      var bookingDateTime = this.booking.bookingDate + " " + event.target.value
      //var endTime = moment(bookingDateTime, 'DD/MM/YYYY HH:mm').add(59, 'minutes').format('HH:mm')
      this.booking.bookingDateTime = moment(bookingDateTime, 'DD/MM/YYYY hh:mm A').format("YYYY-MM-DD HH:mm:ss")
      //this.booking.bookingEndTime = endTime
      this.datekey += 1
      this.timeKey += 1
      this.calculateBookingEndTime()
    },

    downloadToCalender() {
      this.$ics.addEvent('en-us', this.booking.claimantFullName + ' appointment with ' + this.specialist.fullName, '', this.getLocationName(), moment(this.booking.bookingDateTime, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD HH:mm'), this.booking.bookingEndTime)
      this.$ics.download('Appointment-Details-' + moment().unix())
    },

    backToHome() {
      this.$router.push({path: '/'}).catch((err) => {
      })
    },


    openDigram() {
      this.openBodyDiagram()
    },

    setDateInfo() {
      var text = ""
      if (this.booking.bookingTypeId == 7) {
        text = `<b>At:</b> ` + this.formatDate(this.booking.bookingDateTime, 'hh:mm A dddd DD/MM/YYYY', "YYYY-MM-DD HH:mm:ss")
      } else if (this.isWaitlisted == 1) {
        text = `<b>Date & Time:</b> ` + this.formatDate(this.booking.bookingDateTime, 'dddd DD/MM/YYYY', "YYYY-MM-DD HH:mm:ss") + ' (WAITLIST) ' + this.getLocationName()
      } else {
        text = `<b>At:</b> ` + this.formatDate(this.booking.bookingDateTime, 'hh:mm A dddd DD/MM/YYYY', "YYYY-MM-DD HH:mm:ss") + ' ' + this.getLocationName()
      }
      return text
    },

    formatDate(date, format = "YYYY-MM-DD", currentFormat = "YYYY-MM-DD") {
      if (date != '') {
        return utilities.formatDate(date, format, currentFormat)
      }
      return ''
    },

    getSpecialistInfo(locationId, locations) {
      var text = ""
      if (this.specialist.qualificationList) {
        text = this.specialist.qualificationList
        return text
      }

      // if (locationId) {
      //   var value = locations.find((x) => x.id == locationId).shortLocation
      //   if (value) {
      //     return text + ", " + value
      //   }
      // }
      return ""
    },

    getLocationName(fullLocation = false) {
      if (this.booking.locationId && this.locations.length > 0) {
        if (fullLocation) {
          return this.locations.find((x) => x.id == this.booking.locationId).fullLocation.replace(', Australia', "")
        } else {
          return this.locations.find((x) => x.id == this.booking.locationId).shortLocation
        }

      }
      return ""
    },
    getLocationNameOld(fullLocation = false) {
      if (this.originalBooking.locationId && this.locations.length > 0) {
        if (fullLocation) {
          return this.locations.find((x) => x.id == this.originalBooking.locationId).fullLocation.replace(', Australia', "")
        } else {
          return this.locations.find((x) => x.id == this.originalBooking.locationId).shortLocation
        }

      }
      return ""
    },


    getLocationState(id) {
      if (id) {
        return this.locations.find((x) => x.id == id).state
      }
    },
    getCaseTitle() {
      if (this.singleCase && this.singleCase.CaseReference) {
        return ' on Case ' + decodeURIComponent(this.singleCase.CaseID) + ' for ' + decodeURIComponent(this.booking.ClaimantFullName)
      }
      return ''
    },
    setTitle() {
      if (this.displayBookingDetails) {
        if (this.booking.waitlisted && !this.booking.caseId) {
          return "Create a Waitlist Booking - case Details"
        } else if (this.booking.waitlisted && this.booking.caseId) {
          return "Create a Waitlist Booking" + this.getCaseTitle()
        } else {
          if (!this.booking.caseId) {
            return "Create a Booking" + this.getCaseTitle()
          } else {
            return "Create a Booking - case Details"
          }
        }
      } else {
        if (this.booking.caseId && this.booking.waitlisted) {
          return "Waitlist Booking Summary" + this.getCaseTitle()
        } else if (this.booking.waitlisted) {
          return "Waitlist Booking Summary"
        } else if (this.booking.caseId) {
          return "Booking Summary" + this.getCaseTitle()
        } else {
          return "Booking Summary"
        }
      }
    },

    setSubTitle() {
      var subtitle = ""
      if (this.booking.caseId) {
        subtitle = "Enter booking details for the existing case."
      } else {
        subtitle = "Enter the details for the new case."
      }
      return subtitle
    },

    onChartToggleChange(index) {
      switch (index) {
        case 1:
          this.booking.willAcceptEarlier = !this.booking.willAcceptEarlier
          break;
        case 2:
          this.booking.interpreterRequired = !this.booking.interpreterRequired
          this.booking.OrganizeRequired = false
          if (!this.booking.InterpreterRequired) {
            this.booking.InterpreterName = ''
            this.booking.InterpreterCompanyName = ''
            this.booking.InterpreterContactNumber = ''
            this.booking.InterpreterContactEmail = ''
          }
          break;
        case 3:
          this.booking.redHealthMayContactClaimant = !this.booking.redHealthMayContactClaimant
          if (!this.booking.redHealthMayContactClaimant) {
            this.hideWarning = false
          } else {
            this.hideWarning = true
          }
          break;
        case 4:
          this.booking.overPeriodofTime = !this.booking.overPeriodofTime
          if (this.booking.overPeriodofTime) {
            this.booking.accidentDate = ""
          }
          break;
        case 5:
          this.booking.private = !this.booking.private
          break;
        case 6:
          this.booking.otfceRequired = !this.booking.otfceRequired
          break;
        case 7:
          this.booking.callClientAfterAppointment = !this.booking.callClientAfterAppointment
          break;
        case 8:
          this.booking.redHealthMayContactClaimant = !this.booking.redHealthMayContactClaimant
          break;
        case 9:
          this.booking.feeDeferralRequired = !this.booking.feeDeferralRequired
          if (!this.booking.feeDeferralRequired && !this.client.paymentDeferralOption && this.client.clientAlignment == "Plaintiff") {
            this.displayBanner = true
            this.bannerKey += 1
          } else {
            this.displayBanner = false
          }
          break;
        default:
      }
    },

    changeVideoLinkAvailable() {
      this.booking.videoLinkTestStatus = !this.booking.videoLinkTestStatus
    },

    getBookingTypeById(typeId) {
      if (typeId) {
        var type = this.allBookingTypes.find((x) => x.id == typeId)
        if (type) {
          return type.name
        }

      }
      return ""
    },

    deleteFile(index) {
      var file = this.fileParams[index]
      if(this.booking.id) {
        this.$confirm({
          content: 'Are you sure you want to delete this file?',
          onConfirm: async () => {
            this.$store.dispatch('loading/setLoadComponent', true)
            var params = {
              userId: this.user.id,
              userName: this.user.name,
              id: file.BookingFileID,
            }
            await utilities.deleteBookingFileById(params)
            this.$store.dispatch('loading/setLoadComponent', false)
            this.fileParams.splice(index, 1)
          }
        })
      } else {
        this.fileParams.splice(index, 1)
      }
    },
    changeFileType(e, index) {
      this.$set(this.fileParams[index], 'FileTypeID', e)
    },

    async tapButtonConfirmation(states) {
      utilities.hideAlert('.confirm')
      if (states) {
        this.singleCase = this.searchCases[0]
        this.booking.caseId = this.singleCase.id
        await this.callGetCaseAPI()
      } else {
        this.showBookingCinfirmation()
      }
    },

    openBodyDiagram() {
      this.$refs.addBodyDiagramModal.handleModal()
      this.$refs.addBodyDiagramModal.filteredBodyAreas = this.bodyAreas
      this.$refs.addBodyDiagramModal.bodyAreas = _.cloneDeep(this.bodyAreaTags)
      this.$refs.addBodyDiagramModal.handleClick()
    },

    setBodyArea(addedBodyAreas) {
      this.bodyAreaTags = []
      this.bodyAreaTags = addedBodyAreas
    },

    deleteBodyAreaItems(items) {
      items.map((x) => {
        this.deletedBodyTags.push(x.tag)
      })
    },

    checkValidFilesForTPD() {
      const fileTypes = ['MAS Template', 'PIC Template', 'Letter of Instruction', 'Brief']
      const fileCounts = [this.showMAS ? this.booking.MAS : 0, this.showPIC ?this.booking.PIC : 0, this.showSHORT ? this.booking.ShortReport : 0, 1]
      console.log(fileCounts)
      let valid = true
      fileTypes.forEach((file, i) => {
        const id = this.fileTypes.find((x) => x.FileTypeName === file).FileTypeID
        const filter = this.fileParams.filter(x => x.FileTypeID === id)
        if(filter.length < fileCounts[i] && file !== 'Brief') {
          this.fileCountList[i] = fileCounts[i] - filter.length
          valid = false
        } else if (file === 'Brief' && filter.length === 0) {
          this.fileCountList[i] = 1
          valid = false
        } else {
          this.fileCountList[i] = 0
        }
      })
      return valid
    },

    async tapNext() {
      if (!this.validateIncident || !this.validateDateOfBirth || !this.validateReferenceNumber || !this.validateAttendance || !this.validateClaimantName || !this.validateTypeOfClaim || !this.validateBillEmail || !this.validateSendEmail || !this.validateState || !this.validateBookingType || !this.validateInterpreter || !this.validateDeliveryMethods || !this.validateNumOfServices || this.otherBodyAreasError || this.examineeLocationError) {
        this.hasError = true
        this.errorMessage = "Please correct the errors shown above and try again."
        utilities.showAlert(".general-alert-danger")
        return
      }
      if(this.isTPD && !this.checkValidFilesForTPD()) {
        this.$forceUpdate()
        this.tpdFilesDialog = true
        return
      }
      this.showBookingCinfirmation()
      this.summaryKey += 1

      this.hasError = false
      this.checkRescheduleStatus()
      setTimeout(() => {
        utilities.initTooltip()
      }, 300)
    },

    checkRescheduleStatus() {
      this.showMsg1 = false
      this.showMsg2 = false
      if (this.booking.id) {
        var timeLeft = moment().diff(moment(this.originalBookingDateTime, "YYYY-MM-DD HH:mm:ss"), 'hours');
        if (timeLeft < 48) {
          var showMeg = false
          this.bookingLog.map(x => {
            if (x.LogDetails.includes("(7)")) {
              showMeg = true
            }
          })

          if (this.booking.timesRescheduled != '' && this.booking.timesRescheduled > 0) {
            showMeg = true
          }

          if (this.client.redRescheduleEnabled && !showMeg) {
            this.showMsg1 = true
          } else if (!this.client.redRescheduleEnabled || showMeg) {
            this.showMsg2 = true
          }
        }
      }
    },

    showBookingCinfirmation() {
      //If type is File Review
      this.showBookingStatus = true
      this.hideOtherStatus = false
      if (this.booking.bookingTypeId == 6) {
        this.showBookingStatus = false
        this.hideOtherStatus = true
      }

      //If type is phone call
      if (this.booking.bookingTypeId == 7) {
        this.showBookingStatus = true
        this.hideOtherStatus = true
      }

      this.booking.bookingStatus = 3
      this.booking.bookingStatusName = "Booked"
      this.displayBookingDetails = false

      this.displayBookingSummery = true

      if (this.isWaitlisted) {
        this.showBookingStatus = false
        this.hideOtherStatus = true
      }
    },

    calculateBookingEndTime() {
      if (this.booking.bookingTypeId == 6 || this.booking.bookingTypeId == 8 || this.isWaitlisted) {
        return ''
      }

      let endTime = window.moment(this.bookingProps.bookingEndTime, 'HH:mm:ss').format('HH:mm:ss')
      this.booking.bookingEndTime = endTime
      return this.booking.bookingEndTime
    },

    async handleChange(e) {
      if (e && e.length > 0) {
        this.booking.ClaimantCountryDuringBooking = e[0]
        this.booking.ClaimantStateDuringBooking = e[1]
        if (e[0] === e[1] && e[1] === "International") {
          await this.$store.dispatch("loading/setLoadComponent", true);
          this.timeZones = await utilities.getTimeZone()
          this.showTimeZone = true
          await this.$store.dispatch("loading/setLoadComponent", false);
        } else {
          this.timeZoneValue = null
        }
        this.$forceUpdate()
      } else {
        this.booking.ClaimantCountryDuringBooking = null
        this.booking.ClaimantStateDuringBooking = null
      }
    },

    async getDuplicateCase() {
      this.hasToChooseCase = false
      if (!this.singleCase.id) {
        const param = {
          DateofBirth: this.booking.dateOfBirth,
          ClaimantFirstName: this.booking.claimantFirstName,
          ClaimantSurname: this.booking.claimantSurname,
        }
        await this.$store.dispatch("loading/setLoadComponent", true)
        const {clientCase, total} = await utilities.getCasesDuplicate(param)
        const duplicateCase = clientCase.find(item => (item.claimantFirstName === this.booking.claimantFirstName && item.claimantSurname === this.booking.claimantSurname && window.moment(item.dateOfBirth).isSame(window.moment(this.booking.dateOfBirth))))
        if (duplicateCase) this.hasToChooseCase = true
        if (total > 0) {
          this.result = clientCase
          this.dialogVisible = true
        }
        await this.$store.dispatch("loading/setLoadComponent", false)
      }
    },
    selectCase(item) {
      if (item) {
        this.singleCase = item
        this.caseChange = true
        this.booking.isNewCase = false
      }
      this.dialogVisible = false
      if (this.booking.id) {
        this.disableCaseField = true
      } else if (this.booking.caseId) {
        this.disableCaseField = false
      }
      this.tapSubmit(true)
    },
    closeModal() {
      this.result = []
      this.dialogVisible = false
      if (this.displayBookingSummery && this.booking.id == '') this.tapEdit()
    },

    getLocationNameById(id) {
      if (id) {
        return this.locations.find((x) => x.id == id).fullLocation.replace(', Australia', "")
      }
    },

    cleanData() {
      this.showTimeZone = false;
      this.timeZoneValue = null;
      this.booking.ClaimantCountryDuringBooking = null
      this.booking.ClaimantStateDuringBooking = null
      this.bookingExamineeStatus = []
    },

    async tapSubmit(canCreate) {
      if (!this.validateReschedule) {
        this.hasError = true
        return
      }

      if (!canCreate && !this.booking.id && this.booking.isNewCase) {
        await this.getDuplicateCase()
        if (this.dialogVisible) return
      }

      this.$store.dispatch("loading/setLoadComponent", true)
      const available = await utilities.getSpecialistAvailabilities(this.booking.specialistId, '', {AvailabilityID: this.booking.specialistAvailabilityId})
      if (available[0] && available[0].Availabilities) {
        const single = available[0].Availabilities.find(item => this.booking.specialistAvailabilityId === item.AvailabilityID)
        if (!single || single.AvailabilityStatus !== '2' || single.BookingStatus !== 'A') {
          if (!this.bookingProps.tentativeBookingID || (this.bookingProps.tentativeBookingID && single.BookingStatus !== 'H')) {
            this.errorMessage = "Booking Time not available now, please go back to select another availability"
            utilities.showAlert(".alert-danger")
            this.$store.dispatch("loading/setLoadComponent", false)
            return
          }
        } else if (!this.isTPD && single.Location?.LocationID != this.booking.locationId) {

          this.$msgbox({
            message: `The address for this availability has been updated to ${this.getLocationNameById(single.Location.LocationID)}. Please click “Confirm” to book the appointment with this new address, or "Cancel" to pick a different availability`,
            title: 'Warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
          }).then(() => {
            this.booking.locationId = single.Location.LocationID
            this.tapSubmit(true)
          }).catch(() => {
            this.$router.replace('/search-specialist')
          });
          this.$store.dispatch("loading/setLoadComponent", false)
          return
        }
      }

      var bodyAreaObjects = []
      var bodyArea = {}
      if (this.bodyAreaTags.length > 0) {
        this.bodyAreaTags.map((x) => {
          var temp = this.addedBodyArea.filter((y) => y.bodyArea == x.text)[0]
          if (temp == undefined) {
            bodyArea = {
              BodyAreaID: x.value
            }
            bodyAreaObjects.push(bodyArea)
          }
        })
      }

      if (this.isWaitlisted) {
        this.booking.bookingStatus = 16
      } else {
        if (this.booking.bookingStatus == '' || this.booking.bookingStatus == 0) {
          this.booking.bookingStatus = 1
        }
      }

      var bookingEndTime = this.calculateBookingEndTime()
      this.booking.bookingEndTime = bookingEndTime
      console.log(this.singleCase)
      var params = {
        Booking: {
          MAS: this.showMAS ? this.booking.MAS : 0,
          PIC: this.showPIC ? this.booking.PIC : 0,
          ShortReport: this.showSHORT ? this.booking.ShortReport : 0,
          ClientID: this.user.clientId,
          Reassessment: this.booking.Reassessment ? 1 : 0,
          ClientContactID: this.booking.clientContactId,
          DeliveryMethodID: this.booking.DeliveryMethodID,
          CaseID: this.singleCase.CaseID ?? this.singleCase.id,
          SpecialistID: this.booking.specialistId,
          BookingStatus: this.booking.bookingStatus.toString(),
          BookingTypeID: this.booking.bookingTypeId,
          Private: this.booking.private,
          // WillAcceptEarlier: this.booking.willAcceptEarlier,
          IncidentState: this.booking.IncidentState,
          ClaimTypeID: this.booking.ClaimTypeID,
          BookingDateTime: this.booking.bookingDateTime,
          ClientReference: this.booking.ClientReference,
          ClaimantLocation: this.booking.ClaimantLocation || '',
          BookingEndTime: bookingEndTime,
          LocationID: this.booking.locationId,
          FeeDeferralRequired: this.booking.feeDeferralRequired,
          AvailabilityID: this.specialistAvailabilityId,
          OverPeriodofTime: utilities.convertBoolToNum(this.booking.overPeriodofTime),
          VideoLink: this.booking.DeliveryMethodID === 2,
          InterpreterRequired: this.booking.interpreterRequired,
          InterpreterName: this.booking.InterpreterName,
          InterpreterCompanyName: this.booking.InterpreterCompanyName,
          InterpreterContactNumber: this.booking.InterpreterContactNumber,
          InterpreterContactEmail: this.booking.InterpreterContactEmail,
          AccidentDate: this.booking.accidentDate ? moment(this.booking.accidentDate, "YYYY-MM-DD").format('YYYY-MM-DD') : "",
        },
        BodyAreas: bodyAreaObjects,
        PersonConditions: this.booking.PersonConditions.map(item => {
          return {PersonConditionID: item}
        }),
      }

      if (this.booking.isNewCase) {
        params.Case = {
          ClientID: this.user.clientId,
          ClaimantPhone1: utilities.validatePhonenumber(this.booking.claimantPhone1),
          ClaimantPhone2: utilities.validatePhonenumber(this.booking.claimantPhone2),
          ClaimantMobile: utilities.updateMobileCode(utilities.validatePhonenumber(this.booking.claimantMobile)),
          ClaimantEmail: this.booking.claimantEmail,
          ClaimantAddressLine1: this.booking.claimantAddressLine1,
          ClaimantAddressLine2: this.booking.claimantAddressLine2,
          ClaimantCity: this.booking.claimantCity,
          ClaimantState: this.booking.claimantState,
          PreferredGivenName: this.booking.PreferredGivenName,
          Salutation: this.booking.Salutation,
          ClaimantPostcode: this.booking.claimantPostcode,
          ClaimantCountry: 'AU',
          ClaimantFirstName: this.booking.claimantFirstName.trim(),
          ClaimantGivenNames: this.booking.claimantGivenNames,
          ClaimantSurname: this.booking.claimantSurname.trim(),
          DateofBirth: moment(this.booking.dateOfBirth).format('YYYY-MM-DD'),
        }
      } else if (this.singleCase.CaseID && !this.caseChange && !this.booking.id) {
        params.Booking.CaseID = this.singleCase.CaseID
        params.Case = {}
        params.Case.ClaimantFirstName = this.booking.claimantFirstName.trim()
        params.Case.ClaimantGivenNames = this.booking.claimantGivenNames
        params.Case.ClaimantSurname = this.booking.claimantSurname.trim()
        params.Case.ClientID = this.user.clientId
        params.Case.DateofBirth = moment(this.booking.dateOfBirth).format('YYYY-MM-DD')
        params.Case.ClaimantPhone1 = utilities.validatePhonenumber(this.booking.claimantPhone1), params.Case.ClaimantPhone2 = utilities.validatePhonenumber(this.booking.claimantPhone2), params.Case.ClaimantMobile = utilities.updateMobileCode(utilities.validatePhonenumber(this.booking.claimantMobile)),
            params.Case.ClaimantEmail = this.booking.claimantEmail || undefined
      }

      if (this.bookingProps.redReschedule && this.bookingProps.bookingId) {
        params.RedRescheduled = {
          CancelledBookingID: this.bookingProps.bookingId
        }
        params.Booking.OriginalBookingID = this.bookingProps.bookingId
      }

      if (this.bookingProps.tentativeBookingID) {
        params.TentativePreBookingID = this.bookingProps.tentativeBookingID
      }

      if (this.bookingProps.WaitListPreBookingID) {
        params.WaitListPreBookingID = this.bookingProps.tentativeBookingID
      }

      var otherBodyArea = ""
      this.otherBodyAreaTags.map((x) => {
        if (otherBodyArea == "") {
          otherBodyArea = x.text
        } else {
          otherBodyArea = otherBodyArea + "," + x.text
        }
      })
      params.Booking.BodyAreaOther = otherBodyArea
      if (this.booking.ClaimantStateDuringBooking && this.booking.ClaimantCountryDuringBooking) {
        params.Booking.ClaimantStateDuringBooking = this.booking.ClaimantStateDuringBooking
        params.Booking.ClaimantCountryDuringBooking = this.booking.ClaimantCountryDuringBooking
        params.Booking.ClaimantTimeZoneDuringBooking = this.timeZoneValue
      }
      params.Booking.BillTo = this.showBillToEmail ? this.billToText : this.booking.billTo,
          params.Booking.ReportTo = this.showSendReportToOther ? this.reportToText : this.booking.reportTo,
          params.BookingNotes = this.booking.bookingNotes.map(item => {
            return {
              InternalOnly: item.InternalOnly,
              Note: item.Note
            }
          })
      params.Booking.RedHealthMayContactClaimant = this.booking.redHealthMayContactClaimant
      params.Booking.CallClientAfterAppointment = this.booking.callClientAfterAppointment
      params.Booking.OrganizeRequired = this.booking.OrganizeRequired

      if (this.booking.paperworkDue) {
        params.Booking.PaperworkDue = window.moment(this.booking.paperworkDue, "DD/MM/YYYY").format("YYYY-MM-DD")
      }

      if(this.booking.bookingTypeId === 19 || this.booking.bookingTypeId === 8 || this.booking.bookingTypeId === 21 || this.booking.bookingTypeId === 18 || this.booking.bookingTypeId === 6 ) {
        params.Booking.PaperworkProcessed = window.moment().format('YYYY-MM-DD HH:mm:ss')
      }

      await this.callBookingAPI(params)
      // }
    },

    async confirmChange() {
      await this.getContinue(this.currentParam)
      this.confirmDialog = false
      this.currentParam = null
    },

    onChangeSelect(v) {
      if (v === 2) {
        this.currentParam.BookingTypeName = "Independent Medical Examination"
      } else {
        this.currentParam.BookingTypeName = "Independent Medical Examination by Video"
      }
    },

    async getContinue(params) {
      this.$store.dispatch("loading/setLoadComponent", true)

      var callback = (response) => {
        this.disableButton = true
        // Clear changing object
        this.$store.dispatch("booking/setBookingObject", null)
        utilities.clearChangingObject()
        if (this.booking.id) {
          this.successMessage = "Your booking has been rescheduled"
          utilities.showAlert(".alert-waitlisted", false)
          if (this.showMsg1) {
            this.errorMessage = "Please note: if this new appointment date and time is cancelled or the claimant fails to attend a cancellation fee may apply to this booking."
            utilities.showAlert(".rescheduled-alert", false)
            this.$store.dispatch("loading/setLoadComponent", false)
          } else if (this.showMsg2) {
            this.$store.dispatch("loading/setLoadComponent", false)
          } else {
            setTimeout(() => {
              this.$router.push({path: '/'}).catch((err) => {
              })
              this.$store.dispatch("loading/setLoadComponent", false)
            }, 2300)
          }
          window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
        } else {
          this.$store.dispatch("loading/setLoadComponent", false)
        }
      }

      let obj = {...params}
      for (let key in obj.Booking) {
        if (obj.Booking[key] === null || obj.Booking[key] === '') {
          delete obj.Booking[key];
        }
      }

      for (let key in obj.Case) {
        if (obj.Case[key] === null || obj.Case[key] === '') {
          delete obj.Case[key];
        }
      }
      obj.Booking.ClaimantConfirmed = null
      delete obj.Booking.Reassessment
      if(this.booking.OrganizeRequired) {
        obj.Booking.InterpreterName = ''
        obj.Booking.InterpreterCompanyName = ''
        obj.Booking.InterpreterContactNumber = ''
        obj.Booking.InterpreterContactEmail = ''
      }

      await utilities.putBooking(this.booking.id, params, callback)
    },

    handleClose() {
      utilities.hideAlert('.aler-green')
    },

    async callBookingAPI(objectParams) {
      if(this.booking.id) {
        await this.getContinue(objectParams)
        return
      }
      var callback = (response) => {
        this.newBookingId = response
        this.disableButton = true
        console.log(response)
      }

      let obj = {...objectParams}
      for (let key in obj.Booking) {
        if (obj.Booking[key] === null || obj.Booking[key] === '') {
          delete obj.Booking[key];
        }
      }

      for (let key in obj.Case) {
        if (obj.Case[key] === null || obj.Case[key] === '') {
          delete obj.Case[key];
        }
      }

      if(this.booking.OrganizeRequired) {
        obj.Booking.InterpreterName = ''
        obj.Booking.InterpreterCompanyName = ''
        obj.Booking.InterpreterContactNumber = ''
        obj.Booking.InterpreterContactEmail = ''
      }

      var result = await utilities.postBooking(obj, callback)
      if (result) {
        if (this.fileParams.length > 0) {
          let item = []
          await Promise.all(this.fileParams.map(async (x) => {
            if (this.newBookingId != '') {
              try {
                const mimeType = await utilities.getFileMimeType(x.file, x.MimeType || 'application/octet-stream')
                const result = await utilities.postPreSign({
                  ft: mimeType,
                  fn: x.FileName,
                  id: this.newBookingId,
                  FileStatus: this.isTPD ? 1 : 0,
                  FileTypeID: x.FileTypeID,
                })
                let postData = new FormData()
                for (let key in result.fields) {
                  postData.append(key, result.fields[key]);
                }
                postData.append('file', x.file)
                console.log(x)
                const r = await utilities.postImage(result.url, postData)
                if (r) {
                  item = {
                    BookingID: this.newBookingId,
                    FileName: x.FileName,
                    FileStatus: this.isTPD ? 1 : 0,
                    FileTypeID: x.FileTypeID,
                    MimeType: mimeType,
                  }
                  await utilities.postFileRecord(item)
                }
              } catch (error) {
                utilities.showErrorMessage(error.response.data?.message || error.response.data || error)
              }
            }
          }))
        }

        // Clear changing object
        this.$store.dispatch("booking/setBookingObject", null)
        utilities.clearChangingObject()
        var dissmisAlert = false

        if (this.booking.interpreterRequired) {
          var parem = {
            BookingID: this.newBookingId,
            RequestedBy: this.user.id,
            BookingActionRequestStatus: 1,
            RequestedAction: "Interpreter Required",
            UserID: this.user.id,
            Username: this.user.name,
          }
          var callback = (response) => {
          }
          utilities.postBookingAction(parem, callback)
        }

        if (this.isWaitlisted) {
          dissmisAlert = true
          this.showAddCalender = false
          this.successMessage = "Your booking has been waitlisted."
          utilities.showAlert(".alert-waitlisted")

        } else {
          this.showAddCalender = true
          this.successMessage = "Your booking (ID " + this.newBookingId + ") has been confirmed.  You will receive an email confirmation and we will be in touch shortly to help co-ordinate any next steps."
          utilities.showAlert(".aler-green", false)

          if (this.relatedServices.length > 0) {
            setTimeout(() => {
              // utilities.showAlert(".aler-relatedServices", false)
              this.$refs.additionalBookingModal.relatedServices = this.relatedServices
              this.$refs.additionalBookingModal.handleModal()
            }, 100)
          } else {
            this.backToHome()
          }

          if (this.booking.bookingStatus == 2) {
            this.errorMessage = "This tentative appointment will be held for 24 hours. Please confirm the appointment before then, to ensure you keep this spot"
            utilities.showAlert(".tentative-alert", false)

          }
        }

        if (dissmisAlert) {
          setTimeout(() => {
            this.$router.push({path: '/'}).catch((err) => {
            })
            this.$store.dispatch("loading/setLoadComponent", false)
          }, 2300)
        } else {
          this.$store.dispatch("loading/setLoadComponent", false)
        }
      } else {
        this.$store.dispatch("loading/setLoadComponent", false)
      }
    },

    async postBookingRescheduleLog() {
      // var params = {
      //   UserID: this.user.id,
      //   Username: this.user.name,
      //   BookingID: this.booking.id,
      //   LogDetails: 'BookingID ' + this.booking.id + ' has been rescheduled. Reason: ' + this.reason,
      //   LogDate: utilities.timeToBrisbane(moment().format('YYYY-MM-DD HH:mm:ss')),
      // }
      // const noteObj = {
      //   Note: `Booking Rescheduled from ${this.originalSpecialistFullName} ${utilities.formatDate(this.originalBookingDateTime, "DD/MM/YYYY HH:mm", "YYYY-MM-DD HH:mm")} to ${this.specialist.fullName} ${moment(this.booking.bookingDateTime).format('DD/MM/YYYY HH:mm')}. Reason: ${this.reason}`,
      //   NoteDateTime: utilities.timeToBrisbane(moment().format('YYYY-MM-DD HH:mm:ss')),
      //   BookingID: this.booking.id,
      //   InternalOnly: 1,
      // }
      // await utilities.postBookingNote(noteObj)
    },

    callRescheduleEmail() {
      var params = {
        BookingID: this.booking.id,
        BookingDateTime: this.booking.bookingDateTime,
        OldBookingDateTime: this.originalBookingDateTime,
        SpecialistID: this.booking.specialistId,
        OldSpecialistID: this.originalBooking.specialistId,
        SpecialistName: this.specialist.fullName,
        OldSpecialistName: this.originalBooking.sFullName,
        LocationName: this.getLocationName(true),
        OldLocationName: this.getLocationNameOld(true),
        BookingTypeName: this.booking.bookingTypeName,
        ClientName: this.booking.clientName,
        BranchName: this.booking.branchName,
        UserID: this.user.id,
      }
      utilities.postRescheduleEmail(params)
    },

    tapEdit() {
      var originalBooking = _.cloneDeep(this.booking)
      var originalClient = _.cloneDeep(this.client)

      this.displayBookingDetails = true
      this.displayBookingSummery = false
      this.openNotes()

      setTimeout(() => {
        this.booking.reportTo = originalBooking.reportTo
        this.booking.billTo = originalBooking.billTo
        this.booking.caseOwner = originalBooking.caseOwner
        this.client.id = originalClient.id

        // Reload Client Contact
        var selectedContact = this.originalClientContacts.find((x) => x.id == this.booking.caseOwner)
        if (selectedContact && this.$refs.dropdownClientContact) {
          this.$refs.dropdownClientContact.selected = selectedContact
          this.$refs.dropdownClientContact.searchFilter = selectedContact.name
        }

        // Reload Report To
        if (this.booking.reportTo != '') {
          var sendReportTo = this.clientContacts.find((x) => x.userId == this.user.id)
          if (sendReportTo) {
            this.booking.reportTo = sendReportTo.emailAddress
          }
        }

        // Reload Bill To
        if (this.booking.billTo != '') {
          var billTo = this.clientContacts.find((x) => x.userId == this.user.id)
          if (billTo) {
            this.booking.billTo = billTo.emailAddress
          }
        }

        this.defineClearButton()
      }, 300)
    },

    openNotes() {
      this.showAddNote = true
      $('.notes-content').show()
      $('.tab-selected').removeClass('tab-selected')
      $('.notes-heading').addClass('tab-selected')
      $('.files-content').hide()
    },

    openFiles() {
      this.showAddNote = false
      $('.notes-content').hide()
      $('.tab-selected').removeClass('tab-selected')
      $('.files-heading').addClass('tab-selected')
      $('.files-content').show()
    },

    addNoteToBooking(note) {
      if (this.editingIndex !== null) {
        let editNote = {
          Note: note,
          NoteDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          InternalOnly: 0
        }
        this.$set(this.booking.bookingNotes, this.editingIndex, editNote)
      } else {
        let newNote = {
          Note: note,
          NoteDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          InternalOnly: 0
        }
        if(this.booking.id) {
          const param = {
            Note: note.trim(),
            NoteDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            BookingID: this.booking.id,
            InternalOnly: 0,
          }
          var callback = () => {
            this.booking.bookingNotes.push({
              Note: note.trim(),
              NoteDateTime: param.NoteDateTime,
              UsernameLog: this.user.name,
              InternalOnly: 0,
              UserID: this.user.id
            })
            this.$store.dispatch('loading/setLoadComponent', false)
          }
          this.$store.dispatch('loading/setLoadComponent', true)
          utilities.postBookingNote(param, callback)
        } else {
          this.booking.bookingNotes.push(newNote)
        }
      }
      this.openNotes()
    },

    openAddNoteModal(e) {
      this.editingIndex = null
      this.$refs.addNoteModal.addNoteToBooking()
      this.$refs.addNoteModal.handleModal()
    },

    openFilesBox() {
      $('#assetsFieldHandle').trigger('click')
    },

    openManageContactDetails() {
      if (!this.disableCaseField) {
        this.$refs.addClientContactModal.singleCase = this.singleCase
        this.$refs.addClientContactModal.booking = this.booking
        this.$refs.addClientContactModal.setBookingContactDetails()
        this.$refs.addClientContactModal.handleModal()
      }
    },

    openManageAddress() {
      if (!this.disableCaseField) {
        this.$refs.addClientAddressModal.booking = this.booking
        this.$refs.addClientAddressModal.isClient = false
        this.$refs.addClientAddressModal.setBookingAddressDetails()
        this.$refs.addClientAddressModal.handleModal()
      }
    },

    openAddNameModal() {
      if (!this.disableCaseField) {
        if (this.isEditName) {
          this.$refs.addNameModal.editFullName(this.booking.claimantFirstName, this.booking.claimantGivenNames, this.booking.claimantSurname)
        }
        this.$refs.addNameModal.handleModal();
      }
    },

    setName(object) {
      this.booking.claimantFirstName = object.firstName
      this.booking.claimantGivenNames = object.middleName
      this.booking.claimantSurname = object.surname
      this.booking.claimantFullName = utilities.getClaimantFullName(this.booking)
      if (this.booking.claimantFullName) {
        this.isEditName = true
      } else {
        this.isEditName = false
      }
      this.nameKey += 1
      this.$forceUpdate()
      this.checkReassessments()
    },

    dragover(event) {
      event.preventDefault()
      event.currentTarget.classList.add('dark-border-hover')
    },

    dragleave(event) {
      event.currentTarget.classList.remove('dark-border-hover')
    },

    drop(event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.onChange()

      event.currentTarget.classList.add('bg-gray-100')
      event.currentTarget.classList.remove('bg-green-300')
      event.currentTarget.classList.remove('dark-border-hover')
    },

    async onChange() {
      this.filelist = [...this.$refs.file.files]
      if (this.filelist.length > 0) {
        this.filelist.map(async (x) => {
          const mimeType = await utilities.getFileMimeType(x, x.type || 'application/octet-stream')
          var params = {
            FileName: x.name,
            FileTypeID: this.fileTypes.find((x) => x.FileTypeName == 'Letter of Instruction').FileTypeID,
            UploadedBy: this.user.id,
            UploadedByName: this.user.name,
            MimeType: mimeType,
            FileStatus: 0,
            DateUploaded: window.moment().format('YYYY-MM-DD HH:mm:ss'),
            file: x
          }
          if (this.booking.id) {
            this.$store.dispatch('loading/setLoadComponent', true)
            const result = await utilities.postPreSign({
              ft: mimeType,
              fn: params.FileName,
              id: this.booking.BookingID,
              FileStatus: 0,
              FileTypeID: params.FileTypeID,
            })
            let postData = new FormData()
            for (let key in result.fields) {
              postData.append(key, result.fields[key]);
            }
            postData.append('file', x)
            const r = await utilities.postImage(result.url, postData)
            if (r) {
              await utilities.postFileRecord({
                    BookingID: this.booking.id,
                    FileName: x.name,
                    FileStatus: 0,
                    FileTypeID: params.FileTypeID,
                    MimeType: mimeType
                  }
              )
            }

            this.booking.bookingFiles = await utilities.getBookingFileNew({
              BookingID: this.booking.id,
              pageNum: 1,
              pageSize: 999
            })
            this.fileParams = this.booking.bookingFiles
            this.$store.dispatch('loading/setLoadComponent', false)
          } else {
            this.fileParams.push(params)
          }
        })
      }
    },

    remove(i) {
      this.filelist.splice(i, 1)
    },

    async deleteNote(id, index) {
      this.$confirm({
        content: 'Are you sure you want to delete this note?',
        onConfirm: async () => {
          var temp = _.cloneDeep(this.booking.bookingNotes)
          this.booking.bookingNotes = temp.splice(0, index).concat(temp.splice(index + 1, temp.length - 1))
        }
      })
    },

    async setCaseInfo() {

      if (this.singleCase.CaseStatus === '1') {
        this.singleCase.caseStatus = 1
      }
      if (this.singleCase.ClaimantPhone1 || this.singleCase.ClaimantMobile || this.singleCase.ClaimantPhone2 || this.singleCase.ClaimantEmail) {
        this.isEditContact = true
      } else {
        this.isEditContact = false
      }

      if (this.singleCase.ClaimantAddressLine1 || this.singleCase.ClaimantAddressLine2 || this.singleCase.ClaimantCity) {
        this.isEditAddress = true
      } else {
        this.booking.claimantFullAddress = ""
        this.isEditAddress = false

      }

      if (this.singleCase.ClaimantFullName) {
        this.isEditName = true
      } else {
        this.isEditName = false
      }

      this.booking.caseOwner = this.singleCase.CaseOwner
      this.booking.claimantFullName = this.singleCase.ClaimantFullName
      this.booking.claimantFirstName = this.singleCase.ClaimantFirstName
      this.booking.claimantGivenNames = this.singleCase.ClaimantGivenNames
      this.booking.claimantSurname = this.singleCase.ClaimantSurname
      this.booking.dateOfBirth = this.singleCase.DateofBirth
      this.booking.claimantFullAddress = this.singleCase.ClaimantFullName
      this.booking.claimantAddressLine1 = this.singleCase.ClaimantAddressLine1
      this.booking.claimantAddressLine2 = this.singleCase.ClaimantAddressLine2
      this.booking.claimantCity = this.singleCase.ClaimantCity
      this.booking.claimantState = this.singleCase.ClaimantState
      this.booking.claimantPostcode = this.singleCase.ClaimantPostcode
      this.booking.claimantCountry = this.singleCase.ClaimantCountry
      this.booking.claimantMobile = this.singleCase.ClaimantMobile
      this.booking.claimantPhone1 = this.singleCase.ClaimantPhone1
      this.booking.claimantPhone2 = this.singleCase.ClaimantPhone2
      this.booking.claimantEmail = this.singleCase.ClaimantEmail
      this.booking.BookingStatus = 1
      this.nameKey += 1
    },

    async callGetCaseAPI() {
      this.singleCase = await utilities.getCaseByCaseId(this.booking.caseId)
      if (!this.singleCase) {
        this.showContent = false
        return
      }

      await this.setCaseInfo()
    },


    async loadData(object) {
      this.booking.id = object.bookingId ? object.bookingId : null

      if (this.booking.id) {
        const arr = [utilities.getBookingById(this.booking.id, true), utilities.getBookingNotes({
          BookingID: this.booking.id,
          pageNum: 1,
          pageSize: 999
        }), utilities.getBookingFileNew({
          BookingID: this.booking.id,
          pageNum: 1,
          pageSize: 999
        })]
        const r = await Promise.all(arr)
        this.booking = r[0]
        this.fileParams = r[2]
        this.$set(this.booking, 'bookingNotes', r[1])
        this.timeZoneValue = this.booking.ClaimantTimeZoneDuringBooking
        this.originalBooking = _.cloneDeep(this.booking)
        this.originalBookingDateTime = _.cloneDeep(this.booking.bookingDateTime)
        this.originalSpecialistFullName = _.cloneDeep(utilities.getSpecialistFullNameUpper(this.booking.Specialist))
        this.booking.specialistId = object.id ? object.id : ''
        if (!this.booking) {
          this.showContent = false
          return
        }
        this.originalSpecialistId = _.cloneDeep(this.booking.SpecialistID)
        this.bookingLog = await utilities.getBookingLogsById(this.booking.id)
        this.bookingExamineeStatus = [this.booking.ClaimantCountryDuringBooking, this.booking.ClaimantStateDuringBooking]
        this.openFiles()
        this.openNotes()
        this.$forceUpdate()
      }

      this.booking.locationId = object.locationId ? object.locationId : null
      this.states = utilities.getStates()
      this.booking.caseId = object.caseId ? object.caseId : null
      this.booking.specialistId = object.id
      this.booking.bookingTypeId = object.typeId
      this.isWaitlisted = object.waitlisted
      this.booking.clientContactId = object.ClientContactID ? object.ClientContactID : null
      this.specialistAvailabilityId = object.availabilityId ? object.availabilityId : 0
      // this.qualificationId = object.qualificationId ? object.qualificationId : ''
      this.showDelivery = utilities.bookingTypeWithDeliveryMethods(this.booking.bookingTypeId)
      this.booking.DeliveryMethodID = object.defaultDeliveryMethod
      this.deliveryMethods = object.deliveryMethods ? object.deliveryMethods.map(item => {
        return {
          value: item,
          label: item === 1 ? 'In-person' : 'Virtual',
          des: item === 1 ? 'his service will be delivered face to face with the Medical Expert' : 'This service will be delivered by videolink only.'
        }
      }) : []
      if (this.isWaitlisted) {
        this.showBookingStatus = false
        this.hideOtherStatus = false
      }
      if(this.booking.bookingTypeId === 19) {
        this.booking.ClaimTypeID = 3
      }
      const apiArr = [utilities.getClaimTypes(), utilities.getLocations(), utilities.getBodyArea(), utilities.getPersonConditions(), utilities.getClientContactsNew({
        pageNum: 1,
        pageSize: 100
      }), utilities.getFileTypes(), utilities.getBookingTypes(), utilities.getStateCodes(), utilities.getClientById(this.user.clientId)]

      const res = await Promise.all(apiArr)
      this.claimTypes = res[0]
      this.locations = res[1]
      this.client = res[8]
      this.options = res[7]

      this.booking.specialistAvailabilityId = this.specialistAvailabilityId
      var bodyAreas = res[2]
      this.bodyAreas = utilities.getAutoCompleteBodyAreaTags(bodyAreas)

      var personConditions = res[3]
      this.personConditions = utilities.getAutoCompleteTagsUpperCase(personConditions)

      this.booking.videoLinkTestStatus = false

      this.clientContacts = res[4].contacts
      var types = res[5]
      types.map((x) => {
        if (x.FileTypeName == 'Brief' || x.FileTypeName == 'Letter of Instruction' || x.FileTypeName == 'Other') {
          this.fileTypes.push(x)
        } else if (this.isTPD && (x.FileTypeName == 'MAS Template' || x.FileTypeName == 'PIC Template')) {
          this.fileTypes.push(x)
        }
      })
      this.allBookingTypes = res[6].filter(item => item.settings.Client.AllowBooking)
      this.originalClientContacts = _.cloneDeep(utilities.getClientsDropdownAutoCompleteTag(this.clientContacts))
      this.listContact = _.cloneDeep(utilities.getClientsDropdownAutoCompleteTag(this.clientContacts), false)

      if (this.booking.specialistId) {
        this.specialist = await utilities.getSpecialistById(this.booking.specialistId)
        this.booking.bookingDate = window.moment(object.bookingDate, "YYYY-MM-DD").format("DD/MM/YYYY")
        this.booking.bookingTime = window.moment(object.bookingTime, "hh:mm A").format('HH:mm:ss')
        this.qualificationId = this.specialist.Qualifications.map(item => item.QualificationID)

        var bookingDateTime = object.bookingDate + ' ' + object.bookingTime
        this.booking.bookingDateTime = window.moment(bookingDateTime, 'YYYY-MM-DD hh:mm A').format("YYYY-MM-DD HH:mm:ss")
        if (this.booking.bookingDateTime) {
          this.booking.paperworkDue = window.moment(this.booking.bookingDateTime, 'YYYY-MM-DD').businessSubtract(10).format("DD/MM/YYYY")
        }
        this.datekey += 1
        this.timeKey += 1
      }

      if (this.booking.caseId) {
        await this.callGetCaseAPI()
      }
      if (this.booking.id) {
        this.disableCaseField = true
      }
      this.booking.isNewCase = object.isNewCase
      if (this.user.type <= 2) {
        this.showClientContact = true

        var selectedContact = this.listContact.find((x) => x.id == this.user.id)
        if (selectedContact) {
          setTimeout(() => {
            $('.contact-selecter  input').val(selectedContact.name)
            this.$refs.dropdownClientContact.selected = selectedContact
            this.$refs.dropdownClientContact.searchFilter = selectedContact.name
            this.booking.caseOwner = this.user.id
          }, 500)
        }
      }

      if (object.claimantFirstName) {
        this.booking.claimantFirstName = object.claimantFirstName
        this.booking.claimantSurname = object.claimantLastName
        this.booking.claimantFullName = utilities.getClaimantFullName(this.booking)
        if (this.booking.claimantFullName) {
          this.isEditName = true
        } else {
          this.isEditName = false
        }
        this.nameKey += 1
      }
      this.booking.dateOfBirth = object.dateOfBirth

      //set send report to data
      if (!this.booking.id) {
        this.disableCaseField = false
        var user = {
          id: this.user.ClientContact.ClientContactID,
          value: this.user.ClientContact.EmailAddress,
          name: utilities.getContactFullNameUpper(this.user.ClientContact) + '-' + this.user.ClientContact.EmailAddress
        }

        this.booking.billTo = user.value
        this.booking.reportTo = user.value
      }

      if (this.qualificationId) {
        var param = {
          QualificationIDs: this.qualificationId.join(','),
        }
        const services = await utilities.getRelatedService(param)
        this.relatedServices = services.filter(item => item.BookingTypeID === this.booking.bookingTypeId && this.qualificationId.includes(item.QualificationID))
        console.log(this.qualificationId)
      }
      this.checkReassessments()
      this.$store.dispatch("setOriginalObject", this.booking)
      this.$store.dispatch("setNewObject", this.booking)
    },

    saveToLocalStore() {
      localStorage.setItem('storedCase', JSON.stringify(this.singleCase))
      localStorage.setItem('storedClient', JSON.stringify(this.client))
      localStorage.setItem('storedSpecialist', JSON.stringify(this.specialist))
      localStorage.setItem('storedUser', JSON.stringify(this.user))
      localStorage.setItem('storedAddedBodyArea', JSON.stringify(this.addedBodyArea))
      localStorage.setItem('storedAddedConditions', JSON.stringify(this.addedConditions))
    },
  },

  async beforeMount() {
    await this.$store.dispatch("loading/setLoadComponent", true)
    let object = this.$store.getters["booking/getBookingObject"]
    if (object) {
      this.bookingProps = object
      this.isFromSpecialist = object.isFromSpecialist
      await this.loadData(this.bookingProps)
      this.calculateBookingEndTime()
    } else {
      this.showContent = false
    }
    //if (object.isNewCase) {
    this.hideInfo = true
    // }
    if (this.client != undefined && this.client.redHealthMayContactClaimants) {
      this.hideAttendance = false
      this.booking.redHealthMayContactClaimant = true
      this.hideWarning = true
    } else {
      this.hideAttendance = true
      this.hideWarning = false
    }

    if (this.booking.bookingTypeId == 8) {
      this.hideAttendance = true
      this.booking.claimantConfirmed = false
    }

    if (!this.client.paymentDeferralOption && this.client.clientAlignment == "Plaintiff") {
      this.displayBanner = true
    } else {
      this.displayBanner = false
      this.booking.feeDeferralRequired = false
    }
    this.$store.dispatch("loading/setLoadComponent", false)
    this.loaded = true
    this.saveToLocalStore()

    if (this.bookingProps.noResult) {
      utilities.showDialogInfo('No matching claimants found; please enter the details for the new claimant.')
    }

    $('.behalf').keydown((e) => {
      var code = e.keyCode || e.which;
      if (code === 9) {
        this.openAddNameModal()
      }
    });

    $('.date-of-birth').keydown((e) => {
      var code = e.keyCode || e.which;
      if (code === 9) {
        this.openManageContactDetails()
      }
    });

    $('.accient-date').keydown((e) => {
      var code = e.keyCode || e.which;
      if (code === 9) {
        this.claimFocus = true
      }
    });

    setTimeout(() => {
      $(".dropdown-input").attr({
        autocomplete: "off",
      })
    }, 1000)
    utilities.initTooltip()
  },
  mounted() {
    setTimeout(() => {
      $(".dropdown-input").attr({
        autocomplete: "off",
      })

      this.defineClearButton()
    }, 500)
  },
}
</script>

<style scoped>
.search-popup-longer .el-select-dropdown__wrap {
  max-height: 330px;
}
.default-checkbox.tick {
  margin-left: 20px;
  margin-right: 20px;
  height: 40px;
}
::v-deep .el-input-number .el-input__inner {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
